import type { EquipeRow, MudarLinha } from "../equipe-obra.types";
import { opcaoDoProfissional } from "../equipe-obra.utils";
import type { EquipeTabelaProps } from "./types-equipe-tabela";

export function useEquipeTabela({
  linhas,
  papeis,
  profissionais,
  conflitosDe,
  onChange,
  onConfirm,
  onCancel,
  onEdit,
  onRemove,
}: EquipeTabelaProps) {
  const opcoes = profissionais.map(opcaoDoProfissional);

  return {
    opcoes,
    nomeDe: (linha: EquipeRow) =>
      (linha.gravada ? linha.profissionalNome : null) ||
      opcoes.find((opcao) => opcao.value === linha.usuarioId)?.label ||
      papeis.find((papel) => papel.value === linha.papelObraId)?.label ||
      "",
    mudar:
      (linha: EquipeRow): MudarLinha =>
      (patch, limpar) =>
        onChange(linha.id, patch, limpar),
    conflitosDaLinha: (linha: EquipeRow) =>
      conflitosDe && ((usuarioId: string) => conflitosDe(linha, usuarioId)),
    // O Tooltip liga os eventos só nos alvos que existem ao montar: remonta quando as linhas mudam de modo.
    assinatura: linhas
      .map((linha) => `${linha.id}:${linha.editing}:${linha.usuarioId}:${linha.papelObraId}`)
      .join("|"),
    confirmar: (linha: EquipeRow) => () => onConfirm(linha.id),
    cancelar: (linha: EquipeRow) => () => onCancel(linha.id),
    editar: (linha: EquipeRow) => () => onEdit(linha.id),
    remover: (linha: EquipeRow) => () => onRemove(linha.id),
    testIdLinha: (indice: number) => `equipe-obra-row-${indice}`,
    // A falha do último Salvar vence a leitura; em edição a linha fica sem classe.
    classeLinha: (linha: EquipeRow) =>
      linha.saveFailed ? "falhou" : linha.editing ? "" : "leitura",
  };
}
